import { createWebStrategy } from './web.js';

/** @type {import('./web.js').PlatformStrategy} */
let active = createWebStrategy();

/** @returns {import('./web.js').PlatformStrategy} */
export function getPlatform() {
  return active;
}

/** @param {import('./web.js').PlatformStrategy} strategy */
export function setPlatform(strategy) {
  active = strategy;
}

/** @returns {Promise<import('./web.js').PlatformStrategy>} */
export async function resolvePlatform() {
  if (globalThis.__SIGNEDGE_PLATFORM_ID__ === 'electron') {
    const { createElectronStrategy } = await import('./electron.js');
    return createElectronStrategy();
  }
  return createWebStrategy();
}
